export const USER_STATUS = [
    {
        status:0,
        tip:'登录APP'
    },
    {
        status:1,
        tip:'绑定手机'
    },
    {
        status:2,
        tip:'开始答题'
    },
    {
        status:3,
        tip:'今日已参与'
    },
    {
        status:4,
        tip:'去答题',
        message:'去客户端'
    },
    {
        status:5,
        tip:'活动未开始'
    },
    {
        status:6,
        tip:'活动已结束'
    },
]
export const CACHE_KEY = 'SFDTDK'
export const DAY_IN_SECONED = 1000*60*60*24;
export const DURATION = 31;
export const START_DATE = new Date("2021/6/1");

export const POSTERS = [
    'https://cbgccdn.thecover.cn/@/images/20210531/1622445025223039892.jpg', //1
    'https://cbgccdn.thecover.cn/@/images/20210604/1622790442280044941.jpg',//7
    'https://cbgccdn.thecover.cn/@/images/20210604/1622790469338083143.jpg',//14
    'https://cbgccdn.thecover.cn/@/images/20210604/1622790529777063826.jpg',//21
    'https://cbgccdn.thecover.cn/@/images/20210604/1622790548876027089.jpg',//30
]